import { SetFieldValue } from 'modules/core/types/form';
import { IRouteOneLender } from 'modules/core/types/lender';
import { IOption, IRouteOneDealer } from 'modules/core/types';

import { LOAN_VARIABLES_FIELDS_NAMES } from '../consts/fieldNames.const';

export const validateLenderList = (lenderList: IRouteOneLender[] | undefined, setIsValidLenderList: Function) => {
  const isValidLenderList = !!lenderList && lenderList.length > 0;

  setIsValidLenderList(isValidLenderList);

  return isValidLenderList;
};

export const clearLenderList = (setValue: SetFieldValue, isFieldChanged: Function, setHistoryCallback: Function) => {
  setValue(LOAN_VARIABLES_FIELDS_NAMES.LENDER_LIST, []);

  if (isFieldChanged('lenderList')) {
    setHistoryCallback();
  }
};

export const lenderListChangeCallback = (
  setIsValidLenderList: Function,
  isFieldChanged: Function,
  setHistoryCallback: Function,
) => {
  setIsValidLenderList(true);

  if (isFieldChanged('lenderList')) {
    setHistoryCallback();
  }
};

export const getLenderListOptions = (
  dealerId: number | undefined,
  routeOneDealer: IOption,
  routeOneDealers: IRouteOneDealer[],
) => {
  let routeOneLenders: IRouteOneLender[] = [];

  if (routeOneDealer && routeOneDealers) {
    routeOneLenders =
      routeOneDealers.find((dealer) => dealer.route_one_id === routeOneDealer.value)?.route_one_lenders || [];
  } else if (dealerId) {
    routeOneLenders = routeOneDealers.find((dealer) => dealer.id === dealerId)?.route_one_lenders || [];
  } else {
    routeOneLenders = routeOneDealers[0]?.route_one_lenders || [];
  }

  const sortedOptions = routeOneLenders
    ?.map((lender: any) => ({ title: lender.name, value: lender.route_one_id }))
    .sort((a, b) => a.title.localeCompare(b.title));

  return sortedOptions ?? [];
};
